import { createPinia as a } from "pinia";
import { p } from "./piniaPluginApi.BtP4aViR.js";
import { p as o } from "./piniaPluginDatadog.D60SB6ND.js";
import { p as r } from "./piniaPluginLocalStorageCache.C3COZpBN.js";
const i = a();
i.use(p);
i.use(o);
i.use(r);
export {
  i as p
};
